import React from "react";
import { Reveal, SplitText } from "./Reveal";

export default function SectionHeading({ overline, title, desc, center = false, light = false, testid }) {
  return (
    <div className={`${center ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}`} data-testid={testid}>
      {overline && (
        <Reveal variant="fade">
          <span className={`inline-flex items-center gap-2 text-xs font-700 tracking-ultra uppercase ${light ? "text-brand-blue-light" : "text-brand-blue"}`}>
            <span className="h-px w-8 bg-brand-red" />
            {overline}
          </span>
        </Reveal>
      )}
      <h2 className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-800 tracking-tight leading-[1.05] ${light ? "text-white" : "text-ink"}`}>
        <SplitText text={title} />
      </h2>
      {desc && (
        <Reveal variant="up" delay={0.1}>
          <p className={`mt-5 text-base sm:text-lg leading-relaxed ${light ? "text-white/60" : "text-slate"}`}>{desc}</p>
        </Reveal>
      )}
    </div>
  );
}
